import { render, staticRenderFns } from "./list-cadena-carrito.vue?vue&type=template&id=3418ca58"
import script from "./list-cadena-carrito.vue?vue&type=script&lang=js"
export * from "./list-cadena-carrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports